export interface ParsedBulkCaseLine {
  title: string;
}

export interface BulkCaseParseResult {
  cases: ParsedBulkCaseLine[];
  skipped: string[];
}

/**
 * One case per non-empty line. The whole line is the case title.
 * Nothing is split into a file number or client ID, and duplicate lines are kept.
 */
export function parseBulkCaseList(raw: string): BulkCaseParseResult {
  const cases: ParsedBulkCaseLine[] = [];
  const skipped: string[] = [];

  raw.split(/\r?\n/).forEach((line, index) => {
    const title = line.trim();
    if (!title) {
      return;
    }
    if (title.length > 255) {
      skipped.push(`Line ${index + 1} is longer than 255 characters`);
      return;
    }
    cases.push({ title });
  });

  return { cases, skipped };
}
